import { TimePeriod } from 'api/pulse'

export const TIME_PERIOD_OPTIONS = [
  { label: 'Yearly', value: TimePeriod.Yearly },
  { label: 'Quarterly', value: TimePeriod.Quarterly },
  { label: 'Monthly', value: TimePeriod.Monthly },
  { label: 'Weekly', value: TimePeriod.Weekly },
  { label: 'Daily', value: TimePeriod.Daily },
]
